<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
    >
        <path
            d="M5.19446 0C5.60867 0 5.94446 0.335786 5.94446 0.75V5.19444C5.94446 5.60866 5.60867 5.94444 5.19446 5.94444C4.78024 5.94444 4.44446 5.60866 4.44446 5.19444V3.72223H0.75C0.335786 3.72223 0 3.38644 0 2.97223C0 2.55802 0.335786 2.22223 0.75 2.22223H4.44446V0.75C4.44446 0.335786 4.78024 0 5.19446 0Z"
            fill="currentColor"
        />
        <path
            d="M8.52777 2.22223C8.11356 2.22223 7.77777 2.55802 7.77777 2.97223C7.77777 3.38644 8.11356 3.72223 8.52777 3.72223H15.75C16.1642 3.72223 16.5 3.38644 16.5 2.97223C16.5 2.55802 16.1642 2.22223 15.75 2.22223H8.52777Z"
            fill="currentColor"
        />
        <path
            d="M0 8.25C0 7.83579 0.335786 7.5 0.75 7.5H10.5555V6.02777C10.5555 5.61356 10.8913 5.27777 11.3055 5.27777C11.7198 5.27777 12.0555 5.61356 12.0555 6.02777V8.24548L12.0556 8.25L12.0555 8.25452V10.4722C12.0555 10.8864 11.7198 11.2222 11.3055 11.2222C10.8913 11.2222 10.5555 10.8864 10.5555 10.4722V9H0.75C0.335786 9 0 8.66421 0 8.25Z"
            fill="currentColor"
        />
        <path
            d="M13.8889 8.25C13.8889 7.83579 14.2247 7.5 14.6389 7.5H15.75C16.1642 7.5 16.5 7.83579 16.5 8.25C16.5 8.66421 16.1642 9 15.75 9H14.6389C14.2247 9 13.8889 8.66421 13.8889 8.25Z"
            fill="currentColor"
        />
        <path
            d="M8.52777 12.7778C8.11356 12.7778 7.77777 13.1136 7.77777 13.5278C7.77777 13.942 8.11356 14.2778 8.52777 14.2778H15.75C16.1642 14.2778 16.5 13.942 16.5 13.5278C16.5 13.1136 16.1642 12.7778 15.75 12.7778H8.52777Z"
            fill="currentColor"
        />
        <path
            d="M0 13.5278C0 13.1136 0.335786 12.7778 0.75 12.7778H4.44446V11.3055C4.44446 10.8913 4.78024 10.5555 5.19446 10.5555C5.60867 10.5555 5.94446 10.8913 5.94446 11.3055V15.75C5.94446 16.1642 5.60867 16.5 5.19446 16.5C4.78024 16.5 4.44446 16.1642 4.44446 15.75V14.2778H0.75C0.335786 14.2778 0 13.942 0 13.5278Z"
            fill="currentColor"
        />
    </svg>
</template>
